import { defineRoutes } from "@/service/routing/schema";

const base = "/partnerzy";

export const vendorRoutes = defineRoutes({
  "vendor.show": ({ slug }: { slug: string }) =>
    `${base}/${slug}?utm_source=remedium`,
} as const);
